import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { categoryHeaderStyles } from '../../SearchResults.styles';

const CategoryHeader = ({ label }) => (
  <Box sx={categoryHeaderStyles}>
    <Typography variant="medium12">{label}</Typography>
  </Box>
);

CategoryHeader.propTypes = {
  label: PropTypes.string.isRequired,
};

export default memo(CategoryHeader);
